import { setChatbotApiAccessToken } from "@virtual-brain-lib/frontend-api";
import { getChatbotSessionKey } from "@virtual-brain-lib/utils-common";

interface LocalStorage {
	chatbotId: string;
	credentials: {
		accessToken: string;
	};
	isInPreviewMode?: boolean | undefined;
}

export function getAccessToken(chatbotId: string, isInPreviewMode = false) {
	const localStorageValue = JSON.parse(localStorage.getItem("VirtualBrain")!) as
		| LocalStorage[]
		| undefined;

	const chatbot = localStorageValue?.find(
		(value) => value.chatbotId === chatbotId && value.isInPreviewMode === isInPreviewMode,
	);

	const token = chatbot?.credentials?.accessToken;

	if (token) {
		setChatbotApiAccessToken(token);
	}

	return token;
}

export function setAccessToken(chatbotId: string, accessToken: string, isInPreviewMode = false) {
	let localStorageValue = JSON.parse(localStorage.getItem("VirtualBrain")!) as
		| LocalStorage[]
		| undefined;

	const chatbot = localStorageValue?.find(
		(value) => value.chatbotId === chatbotId && value.isInPreviewMode === isInPreviewMode,
	);

	// If we find a chatbot, we update the access token
	if (chatbot) {
		chatbot.credentials.accessToken = accessToken;
	} else if (localStorageValue?.length) {
		// If we don't find a chatbot but the localstorage is not empty, we add it
		localStorageValue?.push({
			chatbotId,
			credentials: {
				accessToken,
			},
			isInPreviewMode,
		});
	} else {
		// If we don't find a chatbot and the localstorage is empty, we create it
		localStorageValue = [
			{
				chatbotId,
				credentials: {
					accessToken,
				},
				isInPreviewMode,
			},
		];
	}

	localStorage.setItem("VirtualBrain", JSON.stringify(localStorageValue));
}

export function clearChatbotSessionId(chatbotId: string) {
	const key = getChatbotSessionKey({
		chatbotId,
		isPreview: Boolean(new URLSearchParams(window.location.search).get("preview")),
	});

	sessionStorage.removeItem(key);
}
